module.exports = __webpack_public_path__ + "static/media/indus5.c1bd99fc.jpg";